import { kea } from 'kea'
import PropTypes from 'prop-types'

import imgixSource from 'lib/utils/imgix-source'
import railsContext from 'lib/selectors/rails-context'

const DEFAULT_SCREEN_WIDTH = 1054
const DEFAULT_SCREEN_HEIGHT = 1169
const MAX_AVATAR_WIDTH = 1024
const AVATAR_THUMBNAIL_SIZE = 50
const IMAGE_PADDING = 20
const MAX_WIDTH_OFFSET = 10
const MAX_HEIGHT_OFFSET = 60
const FOOTER_HEIGHT = 40
const HEADER_HEIGHT = 25
const THUMBNAIL_PADDING = 10

export default kea({
  path: () => ['scenes', 'course', 'profileHeader', 'lightBox'],

  connect: {
    props: [railsContext, ['dpr']]
  },

  actions: () => ({
    setCurrentImage: number => ({ number }),
    openLightBox: true,
    closeLightBox: true,
    nextImage: true,
    previousImage: true,
    setDimensions: (width, height) => ({ width, height }),
    openVideo: true,
    closeVideo: true
  }),

  reducers: ({ actions }) => ({
    isVisible: [
      false,
      PropTypes.bool,
      {
        [actions.openVideo]: () => true,
        [actions.closeVideo]: () => false
      }
    ],
    isLightboxOpen: [
      false,
      PropTypes.bool,
      {
        [actions.openLightBox]: () => true,
        [actions.closeLightBox]: () => false,
        [actions.setCurrentImage]: () => true
      }
    ],
    currentImageNumber: [
      0,
      PropTypes.number,
      {
        [actions.nextImage]: state => state + 1,
        [actions.previousImage]: state => state - 1,
        [actions.setCurrentImage]: (_, { number }) => number
      }
    ],
    screenWidth: [
      0,
      PropTypes.number,
      {
        [actions.setDimensions]: (_, { width }) => width
      }
    ],
    screenHeight: [
      0,
      PropTypes.number,
      {
        [actions.setDimensions]: (_, { height }) => height
      }
    ]
  }),

  selectors: ({ selectors }) => ({
    lightBoxPhotos: [
      () => [(_, props) => props.user, selectors.screenWidth, selectors.screenHeight, railsContext],
      (user, screenWidth, screenHeight, rails) => {
        const { photos, avatarUrl, firstName } = user
        const { dpr } = rails

        const maxWidth = Math.min(
          (screenWidth || DEFAULT_SCREEN_WIDTH) - IMAGE_PADDING - MAX_WIDTH_OFFSET,
          MAX_AVATAR_WIDTH
        )
        const maxHeight =
          (screenHeight || DEFAULT_SCREEN_HEIGHT) -
          IMAGE_PADDING -
          MAX_HEIGHT_OFFSET -
          FOOTER_HEIGHT -
          HEADER_HEIGHT -
          THUMBNAIL_PADDING

        const lightBoxPhotos = [
          {
            src: imgixSource(avatarUrl, maxWidth, maxHeight, 'max', dpr),
            thumbnail: imgixSource(avatarUrl, AVATAR_THUMBNAIL_SIZE, AVATAR_THUMBNAIL_SIZE, 'crop', dpr),
            caption: firstName
          },
          ...photos.map(photo => ({
            src: imgixSource(photo.url, maxWidth, maxHeight, 'max', dpr),
            thumbnail: imgixSource(photo.url, AVATAR_THUMBNAIL_SIZE, AVATAR_THUMBNAIL_SIZE, 'crop', dpr),
            caption: photo.title
          }))
        ]

        return lightBoxPhotos
      },
      PropTypes.array
    ],
    currentImage: [
      () => [selectors.currentImageNumber, selectors.lightBoxPhotos],
      (currentImageNumber, lightBoxPhotos) => {
        const lightBoxPhotosLength = lightBoxPhotos ? lightBoxPhotos.length : 1

        return currentImageNumber % lightBoxPhotosLength
      },
      PropTypes.number
    ]
  })
})
